import { render, staticRenderFns } from "./dialogAnnotation.vue?vue&type=template&id=f05f8fda&"
import script from "./dialogAnnotation.vue?vue&type=script&lang=js&"
export * from "./dialogAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports